<template>
  <el-container v-loading="loading" style="background:white;">
    <el-main id="top" class="font_16" style="padding-left:20px;padding-right:20px;padding-top:70%;">
      <el-row>
        <div style="width:350px;text-align:center;">
          <p>パスワードを変更しました。<br>アプリへ戻ってログインしてください。</p>
        </div>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
export default {
  mounted() {
    window.addEventListener('resize', this.setWindowSize);
    this.setWindowSize();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.setWindowSize)
  },
  data() {
    return {
    };
  },
  methods: {
    setWindowSize() {
      const top = document.getElementById('top');
      let height = document.documentElement.clientHeight;
      top.style.paddingTop = parseInt(height * 0.4) + "px";
    }
  }
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
</style>